import { ComponentType } from 'react';
import { routePaths } from 'constants/routes';
import { TUserPermissionKey, TUserTypeKey } from 'types/authentication';
import {
  Login,
  ForgetPassword,
  Home,
  Components,
  Simulator,
  Main,
  AFunctions,
  Terms,
  Users,
  NewUser,
  Demands,
  FiledDemands,
  NewDemand,
  BudgetControl,
  EvaluationProject,
  ClientDemands,
  NewClientDemand,
  ClientDemandDetail,
  ROPA,
  ThirdPartyAssessment,
  ALI,
  MyAvaliations,
  VerificationCode,
  NewPassword,
  Dashboard,
  ChangePassword,
  FineSimulator,
  SimulatedFines,
  LawyerManagement,
} from '../pages';

export interface IRoute {
  path: string;
  component: ComponentType<any>;
  exact?: boolean;
  isPrivate?: boolean;
  isPublic?: boolean;
  userType?: TUserTypeKey;
  policy?: TUserPermissionKey;
}

export const mainRoutes: IRoute[] = [
  {
    path: routePaths.home,
    component: Home,
    isPrivate: true,
  },
  {
    path: routePaths.functions,
    component: AFunctions,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.demands,
    component: Demands,
    isPrivate: true,
    exact: true,
    userType: 'admin',
  },
  {
    path: routePaths.filedDemands,
    component: FiledDemands,
    isPrivate: true,
    exact: true,
    userType: 'admin',
  },
  {
    path: routePaths.newDemand,
    component: NewDemand,
    isPrivate: true,
    exact: true,
    userType: 'admin',
  },
  {
    path: routePaths.editDemands,
    component: NewDemand,
    isPrivate: true,
    exact: true,
    userType: 'admin',
  },
  {
    path: routePaths.users,
    component: Users,
    isPrivate: true,
    exact: true,
    policy: 'UsersManagement',
    // userType: 'admin',
  },
  {
    path: routePaths.newuser,
    component: NewUser,
    isPrivate: true,
    exact: true,
    policy: 'UsersManagement',
  },
  {
    path: routePaths.editusers,
    component: NewUser,
    isPrivate: true,
    exact: true,
    // userType: 'admin',
  },
  {
    path: routePaths.terms,
    component: Terms,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.budgetControl,
    component: BudgetControl,
    isPrivate: true,
    exact: true,
    policy: 'BudgetControl',
  },
  {
    path: routePaths.evaluationProject,
    component: EvaluationProject,
    isPrivate: true,
    exact: true,
    policy: 'EvaluationNewProjects',
  },
  {
    path: routePaths.evaluationProjectDetail,
    component: EvaluationProject,
    isPrivate: true,
    exact: true,
    policy: 'EvaluationNewProjects',
  },
  {
    path: routePaths.clientDemands,
    component: ClientDemands,
    isPrivate: true,
    userType: 'client',
    exact: true,
  },
  {
    path: routePaths.newClientDemands,
    component: NewClientDemand,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.editClientDemands,
    component: NewClientDemand,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.detailsClientDemands,
    component: ClientDemandDetail,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.ropa,
    component: ROPA,
    isPrivate: true,
    exact: true,
    policy: 'ROPA',
  },
  {
    path: routePaths.ropaDetails,
    component: ROPA,
    isPrivate: true,
    exact: true,
    policy: 'ROPA',
  },
  {
    path: routePaths.ali,
    component: ALI,
    isPrivate: true,
    exact: true,
    policy: 'ALI',
  },
  {
    path: routePaths.aliDetail,
    component: ALI,
    isPrivate: true,
    exact: true,
    policy: 'ALI',
  },
  {
    path: routePaths.thirdPartyAssessment,
    component: ThirdPartyAssessment,
    isPrivate: true,
    exact: true,
    policy: 'TPA',
  },
  {
    path: routePaths.thirdPartyAssessmentDetails,
    component: ThirdPartyAssessment,
    isPrivate: true,
    exact: true,
    policy: 'TPA',
  },
  {
    path: routePaths.myAvaliations,
    component: MyAvaliations,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.dashBoard,
    component: Dashboard,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.changePassword,
    component: ChangePassword,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.fineSimulator,
    component: FineSimulator,
    isPrivate: true,
    exact: true,
  },
  {
    path: routePaths.lawyerManagement,
    component: LawyerManagement,
    isPrivate: true,
    exact: true,
    userType: 'admin',
  },
  {
    path: routePaths.simulatedFines,
    component: SimulatedFines,
    isPrivate: true,
    exact: true,
  },
];

export const appRoutes: IRoute[] = [
  {
    path: routePaths.simulate,
    component: Simulator,
    isPublic: true,
  },
  {
    path: routePaths.login,
    component: Login,
    exact: false,
    isPublic: true,
  },
  { path: routePaths.forgetPassword, component: ForgetPassword, exact: false, isPublic: true },
  {
    path: '/components',
    component: Components,
  },
  {
    path: '/verificationCode',
    component: VerificationCode,
  },
  {
    path: '/newPassword',
    component: NewPassword,
  },
  { path: routePaths.main, component: Main, exact: false },
];
